// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3145999f","239":"660eadaf","455":"ab233246"}[chunkId] + ".chunk.js";
};